<div id="olmap" class="map-container"></div>
<div id="popup" class="ol-popup">
    <div id="popup-content"></div>
  </div>
  
